.AddressHintContainer
    position: relative
    width: 100%
    height: 0
    box-sizing: border-box
    z-index: 999
    .AddressHint
        position: absolute
        top: 10px
        left: 0
        width: 100%
        height: 40px
        border: 1px solid rgb($globalSettingsStrokeSecondary)
        border-radius: $globalButtonRounding
        background: rgb($globalSettingsBackgroundPrimary)
        display: flex
        align-items: center
        padding: 0 10px
        cursor: pointer
        &:hover
            background: rgb($globalSettingsBackgroundTertiary)
